<template>
  <Header12 />
  <div class="body">
    <section class="background-clair">
      <MenuTitle title="Soft Skills" srcImg="/images/pages/organisme-formation.jpg" backgroundSpan="span-background" />
    </section>
    <section class="mb-3">
      <NavLeft tab="soft-skills" breadcrumb1="" breadcrumb2="Soft Skills" />
    </section>
    <section class="background-blue">
      <Programs />
    </section>
    <section class="background-orange">
      <PoleDeFormation />
    </section>
    <section class="background-rose">
      <AvisClient :idCategory="76" />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue'
import NousContacter from '@/components/emci/NousContacter/index.vue'
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
import AvisClient from '@/components/emci/AvisClient/index.vue';
import PoleDeFormation from '@/components/emci/PoleDeFormation/index.vue'
import Programs from './programs.vue'
useHead({
  title: "EMCI organisme de formation - programme de formation soft skills",
  meta: [
    {
      name: "description",
      content: "EMCI propose des programmes de formation qui renforcent jes compétences comportementales ou sokt skills"
    }
  ]
})
</script>

<style scoped>
.body {

  overflow: hidden !important;
  margin-top: 120px;
}

.background-orange {
  background: #FFD186;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }
}
</style>